import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import router from '@/router'
import lookups from '@/assets/json/clientLookups.json'

const fetchInfo = async () => {
  return await apiHelperService.get(`/api/individual/info`)
}
const getCitizenServiceDetailsApi = async (
  unifiedNumber,
  identityNumber,
  serviceTransactionId,
  requestNumber
) => {
  const personFileInput = {
    unifiedNumber,
    identityNumber: identityNumber,
    serviceTransactionId,
    requestNumber
  }
  return await apiHelperService.post(
    `/api/citizenServices/draft/getCitizenServiceDetails`,
    personFileInput
  )
}

const getCommonValues = async () => {
  const formStore = useFormStore()
  const { familyBookAddChild, issueFirstFamilyBook, familyBookAddWifeOrHusband } =
    lookups.ServiceTransactions
  const serviceTransactionId = router.currentRoute.value.params.serviceId

  const res = await fetchInfo()
  const {
    englishFullName,
    arabicFullName,
    identityNumber,
    passportNumber,
    familyBookNumber,
    arabicFatherName,
    arabicFirstName,
    arabicFourthName,
    arabicGrandName,
    englishFatherName,
    englishFirstName,
    englishFourthName,
    englishGrandName,
    faithId,
    professionId,
    religionId,
    fileSequence,
    familyBookCityCode,
    familySequence,
    unifiedNumber
  } = res

  formStore.form.setValues({
    applicantEngFullName: englishFullName,
    applicantArbFullName: arabicFullName,
    identityNumber: identityNumber,
    localPassportNumber: passportNumber,
    applicantArbFatherName: arabicFatherName,
    applicantArbFirstName: arabicFirstName,
    applicantArbFourthName: arabicFourthName,
    applicantArbThirdName: arabicGrandName,
    applicantEngFatherName: englishFatherName,
    applicantEngFirstName: englishFirstName,
    applicantEngFourthName: englishFourthName,
    applicantEngThirdName: englishGrandName,
    applicantFaithId: faithId,
    applicantProfessionId: professionId,
    applicantReligionId: religionId,
    arabicName: arabicFullName,
    familyMemArbFatherName: arabicFatherName,

    familyBooKFamilySequence: familySequence,
    fileSeqNo: fileSequence,
    familyBookCityCode,
    personUnifiedNumber: unifiedNumber,
    sponsorNumber: unifiedNumber
  })
  if (
    !formStore.draft.request.requestNumber &&
    [familyBookAddChild, issueFirstFamilyBook, familyBookAddWifeOrHusband].includes(
      +serviceTransactionId
    )
  ) {
    const citizenRes = await getCitizenServiceDetailsApi(
      unifiedNumber,
      identityNumber,
      serviceTransactionId
    )
    formStore.draft.request = {
      ...formStore.draft.request,
      ...(identityNumber ? citizenRes.data.localServices : citizenRes)
    }
  }
}

export default async function () {
  getCommonValues()
}
